import React from 'react';
import { ModuleBase, Text, Stack, Link, ResponsiveImage } from '@/components';
import classNames from 'classnames';
import { animControllerInView, fadeIn } from '@/animations';
import { SideBySideModuleModel } from './SideBySideModule';

const OurWorkCTA = (data: SideBySideModuleModel) => {
  const { alignment, title, image, link1, link2 } = data.props;

  return (
    <ModuleBase
      noPadding
      data={{ ...data, props: { ...data.props, backgroundColour: '#ae2d2a' } }}
      className={classNames(
        'OurWorkCTA relative flex flex-col items-center lg:flex-row',
        alignment === 'Right' ? 'justify-end' : 'justify-start',
      )}
    >
      {image && (
        <Stack
          animation={animControllerInView({ amount: 0.3 })}
          className="relative aspect-square w-full overflow-hidden sm:aspect-[unset] sm:h-[500px] lg:min-h-[600px] lg:w-1/2 xl:min-h-[700px]"
        >
          {image && image.desktopImage && (
            <ResponsiveImage
              animation={fadeIn}
              image={image.desktopImage}
              widths={{ xs: 425, sm: 650, md: 758, lg: 512, xl: 720, xxl: 950 }}
              heights={{ xs: 425, sm: 500, md: 500, lg: 600, xl: 700, xxl: 700 }}
            />
          )}
          <div className="absolute top-2/4 left-2/4 block aspect-square h-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white lg:h-auto lg:w-full" />
        </Stack>
      )}

      <div className="left-0 flex w-full items-center py-10 lg:absolute lg:h-full lg:py-0">
        <div
          className={classNames(
            'container flex lg:h-full lg:py-10 xl:py-18',
            alignment === 'Right' ? 'lg:justify-start' : 'lg:justify-end',
          )}
        >
          <Stack
            className={classNames(
              'flex w-full flex-col lg:w-1/2 lg:justify-between',
              alignment === 'Right' ? 'lg:pr-9' : 'lg:pl-9',
            )}
          >
            {title && (
              <Text
                className="text-style-h2 text-[#f5c9c7] lg:text-left lg:text-[80px] xl:text-[110px] xl:leading-[95%]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}

            {(link1 || link2) && (
              <div className="mt-5 flex w-full flex-col gap-5 lg:flex-row">
                {link1 && (
                  <Link animate className="btn primary v2 btn-from-bg !text-[#ae2d2a] hover:!text-white" link={link1} />
                )}
                {link2 && <Link animate className="btn secondary v2 btn-from-bg" link={link2} />}
              </div>
            )}
          </Stack>
        </div>
      </div>
    </ModuleBase>
  );
};

export default OurWorkCTA;
